import { formatToDate } from 'brazilian-values'

/**
 * Converte string YYYY-MM-DD para data formatada brasileira DD/MM/AAAA
 * @param {string} dateString - Data no formato YYYY-MM-DD
 * @returns {string} Data formatada ou '-' se inválida
 */
export const parseLocalDate = (dateString) => {
  if (!dateString || typeof dateString !== 'string') {
    return '-'
  }

  const dateRegex = /^\d{4}-\d{2}-\d{2}$/
  if (!dateRegex.test(dateString)) {
    return '-'
  }

  const [year, month, day] = dateString.split('-').map(Number)
  const date = new Date(year, month - 1, day)

  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return '-'
  }

  return formatToDate(date)
}
